import { CreateSingleton, Values } from "@pdfking/tfunc"
import { createRouter, createWebHashHistory } from "vue-router"
import register_dom_update from "../navigation/register_dom_update"
import state from "../state/main"
import navigate from "./navigate"
import urls, { DEFAULT_VIEW } from "./urls"

const remove_hash = () =>
  history.replaceState(
    "",
    document.title,
    window.location.pathname + window.location.search
  )

const get_router = CreateSingleton(() => {
  const router = createRouter({
    history: createWebHashHistory(),
    routes: Values(urls),
  })

  router.afterEach((to, from) => {
    const start = from.name || DEFAULT_VIEW
    const end = to.name || DEFAULT_VIEW

    if (end == DEFAULT_VIEW) remove_hash()

    if (start == end) {
      // @ts-expect-error TS2339
      if (start != DEFAULT_VIEW) state.track_event(`${start}_update`, start)
    } else {
      // @ts-expect-error TS2339
      if (start != DEFAULT_VIEW) state.track_event(`${start}_close`, start)
      // @ts-expect-error TS2339
      if (end != DEFAULT_VIEW) state.track_event(`${end}_start`, end)
    }
  })

  register_dom_update({
    before: () => navigate(),
  })

  return router
})

export default get_router
